import { ContentTypeView, ContentView } from '../api/client'

export function isAd(content: ContentView): boolean {
    return (
        content.contentType === ContentTypeView.FacebookAdComment ||
        content.contentType === ContentTypeView.InstagramAdComment ||
        content.contentType === ContentTypeView.TikTokAdComment
    )
}
